import React from "react";
import PropTypes from "prop-types";
import { Button, ValidationGroup } from "devextreme-react";
import ArrayStore from "devextreme/data/array_store";
import inputs, { Input } from "./inputs";
import api from "../api";
import {
  listaRegiones,
  listaDirecciones,
} from "../../../../../services/listasApi";

const inputName2DBTransaltor = {
  nombreRazonSocial: "RAZON_SOCIAL_BP",
  rutRazonSocial: "RUT_BP",
  calle: "DIRECCION",
  numeroDeCalle: "NUMERO",
  telefono: "TEL_FIJO",
  ciudad: "CIUDAD",
  region: "REGION",
  comuna: "COMUNA",
  correoElectronico: "CORREO",
  tasa: "TASA",

  nombreRL: "REP_LEGAL_NOMBRE",
  apellidoPaternoRL: "REP_LEGAL_AP1",
  apellidoMaternoRL: "REP_LEGAL_AP2",
  rutRL: "REP_LEGAL_RUT",
};

class Step1 extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      initialized: false,
      regiones: [],
      comunas: [],
      companyId: null,
    };
  }

  componentDidUpdate = async () => {
    const { companyId } = this.props;
    const { loading, initialized } = this.state;

    if (!this.state.companyId && companyId) {
      this.setState({ companyId });
    } else if (companyId && !loading && !initialized) {
      await this.setInitialValues();
    }
  };

  componentDidMount = async () => {
    const {
      steps: { step1 },
    } = this.props;

    // * Load values if coming back from other step
    if (step1.nombreRazonSocial) {
      this.setState({ ...step1, initialized: true });
      return;
    }
  };

  setInitialValues = async () => {
    this.setState({ loading: true }, async () => {
      const { companyId } = this.props;

      const initialState = {};
      let direcciones, regiones;
      let tasa = 1;
      let dbInputNames = [];

      try {
        direcciones = await (await listaDirecciones()).json();
        regiones = await (await listaRegiones()).json();

        const { E_DATOS_BP } = await api.getRepresentanteLegal(companyId);

        if (E_DATOS_BP) {
          tasa = E_DATOS_BP.TASA;
          dbInputNames = Object.keys(E_DATOS_BP);
        }

        inputs.step1.forEach((input) => {
          const inputNameDBTranslation = inputName2DBTransaltor[input.name];

          if (input.defaultValue) {
            initialState[input.name] = input.defaultValue;
          } else if (dbInputNames.includes(inputNameDBTranslation)) {
            initialState[input.name] = E_DATOS_BP[inputNameDBTranslation];
          }
        });
      } catch (error) {
        console.error("error: ", error);
      } finally {
        this.setState({
          ...initialState,
          initialized: true,
          direcciones: direcciones.ListadoDirecciones,
          regiones: regiones.Regiones,
          tasa,
          loading: false,
        });
      }
    });
  };

  handleChange = (value, input) => {
    let newState = {}
    if (input === "telefono") {
      newState = { ...this.state, [input]: value.replace(/\D/g, "") };
    } else {
      newState = { ...this.state, [input]: value };
    }
    this.setState(newState);
  };

  handleStepUpdate = (params) => {
    const { updateStepValues } = this.props;
    const { isValid } = params.validationGroup.validate();

    if (isValid) {
      updateStepValues("step1", this.state);
    }
  };

  setInputProps = (input) => {
    let { region, direcciones, regiones } = this.state;
    region = region && `${region}`;

    const inputProps = {
      input,
      handleChange: this.handleChange,
      value: this.state[input.name],
    };

    if (input.name === "region") {
      inputProps.input.dataSource = new ArrayStore({
        data: regiones || [],
        key: "Cod",
      });
      inputProps.input.displayExpr = "Text";
      inputProps.input.valueExpr = "Cod";
      inputProps.value = region;
    } else if (input.name === "comuna") {
      let comunas = [];

      if (region) {
        direcciones.some((dir) => {
          if (dir.IdRegion === region) {
            comunas = dir.Comunas;
            return true;
          }
          return false;
        });
      }

      inputProps.input.dataSource = new ArrayStore({
        data: comunas,
        key: "DescripcionCommuna",
      });
      inputProps.input.displayExpr = "DescripcionCommuna";
      inputProps.input.valueExpr = "DescripcionCommuna";
    } else if (input.name === "ciudad") {
      let ciudades = [];

      if (region) {
        direcciones.some((dir) => {
          if (dir.IdRegion === region) {
            ciudades = dir.Ciudades;
            return true;
          }
          return false;
        });
      }

      inputProps.input.dataSource = new ArrayStore({
        data: ciudades,
        key: "DescripcionCiudad",
      });
      inputProps.input.displayExpr = "DescripcionCiudad";
      inputProps.input.valueExpr = "DescripcionCiudad";

    }

    return inputProps;
  };



  render() {
    const { loading, initialized } = this.state;

    if (loading || !initialized) {
      return <div id="cotizaciones-step1">Cargando...</div>;
    }

    return (
      <div id="cotizaciones-step1">
        <span>
          Revisa los datos de la empresa y en caso de encontrar algún error puedes corregir el campo
        </span>
        <ValidationGroup className="cotizaciones-step" style={{width: "55%"}}>
          {inputs.step1.map((input) => {
            const inputProps = this.setInputProps(input);
            return (
              <React.Fragment key={input.name}>
              <Input {...inputProps} />

                {input.name === "tasa" && (
                  <div className="form-separator">
                    <hr />
                  </div>
                )}
              </React.Fragment>
            );
          })}
          <div></div>
        <div style={{ justifyContent: "flex-end"}} className="cotizaciones-form-buttons">
          <Button
              key="step1"
              text="Siguiente"
              type="success"
              className="next-button"
              onClick={this.handleStepUpdate}
              useSubmitBehavior
              style={{height: 40}}
              disabled={!(this.state.correoElectronicoRL && this.state.correoElectronicoRL.length)
                        || !(this.state.tipoRemuneracion && this.state.tipoRemuneracion.length)
                        || !(this.state.mesRemuneracion && this.state.mesRemuneracion.length)
                        || !(this.state.anoRemuneracion && String(this.state.anoRemuneracion).length)
                        || !(this.state.telefono && this.state.telefono.length)
                      }
            />
        </div>

        </ValidationGroup>
      </div>
    );
  }
}

Step1.propTypes = {
  updateStepValues: PropTypes.func.isRequired,
  onInputChange: PropTypes.func,
};

export default Step1;
